@if (isMobileOpen) {
    <div class="sidebar-backdrop" (click)="closeMobileSidebar()"></div>
}
<aside class="sidebar" [class.collapsed]="isCollapsed" [class.mobile-open]="isMobileOpen">
    <div class="sidebar-header" [class.collapsed]="isCollapsed">
        @if (!isCollapsed) {
            <div class="logo">
                <span class="logo-text">Easy Liens FL</span>
            </div>
        }
        <button class="toggle-btn desktop-only" (click)="toggleSidebar()" aria-label="Toggle sidebar">
            <hugeicons-icon [icon]="isCollapsed ? menuIcon : collapseIcon" [size]="20"
                color="currentColor"></hugeicons-icon>
        </button>
        <button class="toggle-btn mobile-only" (click)="closeMobileSidebar()" aria-label="Close menu">
            <hugeicons-icon [icon]="collapseIcon" [size]="20" color="currentColor"></hugeicons-icon>
        </button>
    </div>

    <nav class="sidebar-nav">
        <ul class="nav-list">
            @for (item of navItems; track item) {
                @if (hasAccess(item)) {
                    <li class="nav-item">
                        <a [routerLink]="item.route" routerLinkActive="active" class="nav-link" [title]="item.label"
                            (click)="onNavClick()">
                            <span class="nav-icon">
                                <hugeicons-icon [icon]="item.icon" [size]="20" color="currentColor"></hugeicons-icon>
                            </span>
                            @if (!isCollapsed) {
                                <span class="nav-label">{{ item.label }}</span>
                            }
                        </a>
                    </li>
                }
            }
        </ul>
    </nav>

    <div class="sidebar-footer">
        @if (!isCollapsed) {
            <div class="user-info">
                <div class="user-details">
                    <div class="user-name">{{ currentUser?.email || 'Guest' }}</div>
                    <div class="user-role">{{ currentUser?.role || 'Guest' }}</div>
                </div>
            </div>
        }
        <button class="logout-btn" aria-label="Logout" (click)="logout()">
            <hugeicons-icon [icon]="logoutIcon" [size]="20" color="currentColor"></hugeicons-icon>
        </button>
    </div>
</aside>